import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ReferralActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Referral/ReferralBrowser")
	}

	render() {
		return (
			<Activity 
				name="Referral"
				RenderedComponent={this.RenderedComponent}
				context="Referral-RE"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ReferralActivity)
